import { mockCustomerDetails } from '@domgen/dgx-fe-common';
import { PaysafeCustomerDetails } from '../../models/paysafe/paysafe-customer-details.interface';
import { mockPaysafeBillingDetails } from './paysafe-billing-details.mock';
import { mockPaysafeShippingDetails } from './paysafe-shipping-details.mock';

export const mockPaysafeCustomerDetails: PaysafeCustomerDetails = {
  holderName: `${mockCustomerDetails.firstName} ${mockCustomerDetails.surname}`,
  billingDetails: mockPaysafeBillingDetails,
  shippingDetails: mockPaysafeShippingDetails,
};
